import { Component } from 'react';
/**
 * Abstract component to display a list of chat messages, grouped by sender.
 *
 * @augments PureComponent
 */
class AbstractMessageContainer extends Component {
    /**
     * Iterates over all the messages and creates nested arrays which hold
     * consecutive messages sent by the same participant.
     *
     * @private
     * @returns {Array<Array<Object>>}
     */
    _getMessagesGroupedBySender() {
        const messagesCount = this.props.messages.length;
        const groups = [];
        let currentGrouping = [];
        let currentGroupParticipantId;
        let currentPrivateMessage;
        for (let i = 0; i < messagesCount; i++) {
            const message = this.props.messages[i];
            if (message.participantId === currentGroupParticipantId && message.privateMessage === currentPrivateMessage) {
                currentGrouping.push(message);
            }
            else {
                currentGrouping.length && groups.push(currentGrouping);
                currentGrouping = [message];
                currentGroupParticipantId = message.participantId;
                currentPrivateMessage = message.privateMessage;
            }
        }
        currentGrouping.length && groups.push(currentGrouping);
        return groups;
    }
}
AbstractMessageContainer.defaultProps = {
    messages: []
};
export default AbstractMessageContainer;
